import { getHtmlStyle, computeColor, computeUnit } from '../transfer';
import { htmlEncode } from '../util';
import { customEventTypeAttr, customEventFunAttr } from '../event';

export function computeFontStyle(fontStyle) {
  const computeStyle = {};

  const styleArr = fontStyle.split('|');

  if (~styleArr.indexOf('bold')) computeStyle.fontWeight = 'bold';
  if (~styleArr.indexOf('italic')) computeStyle.fontStyle = 'italic';
  if (~styleArr.indexOf('underline')) computeStyle.textDecoration = 'underline';
  if (~styleArr.indexOf('delete')) computeStyle.textDecoration = 'line-through';

  return computeStyle;
}

const text = {
  render(node) {
    const { props } = node;
    const { attrs, style, action } = props;
    const { color, size, style: fontStyle, overflow = 'dot', maxLine = 0, lineSpace } = attrs;

    let computeStyle = Object.assign({}, style);

    // 字体颜色
    if (color) {
      computeStyle.color = computeColor(color);
    }

    // 字体大小
    if (size) {
      computeStyle.fontSize = computeUnit(size);
    }

    // 字体样式
    if (fontStyle) {
      computeStyle = Object.assign({}, computeStyle, computeFontStyle(fontStyle));
    }

    // 行高
    if (lineSpace) {
      const fontSize = computeStyle.fontSize || '14px';
      const lineHeight = `${parseInt(fontSize, 10) + parseInt(computeUnit(lineSpace), 10)}px`;
      computeStyle.lineHeight = lineHeight;
    }

    // 长单词换行
    computeStyle.wordBreak = 'break-all';

    if (overflow || maxLine) {
      computeStyle.overflow = 'hidden';

      if (maxLine) {
        const fontSize = parseInt(computeStyle.fontSize || '14px', 10);
        const lineHeight = parseInt(computeStyle.lineHeight || `${fontSize * 1.5}px`, 10);
        const height = `${lineHeight * maxLine}px`;

        computeStyle.maxHeight = height;

        // for chrome
        computeStyle.display = '-webkit-box';
        computeStyle.WebkitBoxOrient = 'vertical';
        computeStyle.WebkitLineClamp = maxLine;
      }
    }

    // 支持给text加链接
    if ((action.actionCmd === 'browser' || action.actionCmd === 'web' || action.actionCmd === 'plugin') && action.actionData && 'javascript:;' !== action.actionData) {
      // 兼容配置链接时有url属性actionData值不会url的情况跳转情况
      if (action.actionCmd === 'web' && action.actionData && 'javascript:;' !== action.actionData && action.actionData.indexOf('http') !== 0 && attrs && attrs.url && attrs.url.indexOf('http') === 0) {
        return `<a target="_blank" href="${action.actionData}" style="${getHtmlStyle(computeStyle)}" title="${htmlEncode(String(attrs.text))}" onclick="window.open('${attrs.url}')">${htmlEncode(String(attrs.text))}</a>`;
      }
      return `<a target="_blank" href="${action.actionData}" style="${getHtmlStyle(computeStyle)}" title="${htmlEncode(String(attrs.text))}">${htmlEncode(String(attrs.text))}</a>`;
    }
    if (action.type) {
      return `<div title="${htmlEncode(String(attrs.text))}" style="${getHtmlStyle(computeStyle)}" ${customEventTypeAttr}="${action.type}" ${customEventFunAttr}="${action.fun}">${htmlEncode(String(attrs.text))}</div>`;
    }
    return `<div title="${htmlEncode(String(attrs.text))}" style="${getHtmlStyle(computeStyle)}">${htmlEncode(String(attrs.text))}</div>`;
  },
};

export default text;
